<div class="container-fluid py-4 bg-light min-vh-100">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2 class="fw-bold mb-0 text-dark"><i class="bi bi-wallet2 text-success me-2"></i>Gestión de comisiones</h2>
  </div>

  <!-- TABS NAV -->
  <ul class="nav nav-pills mb-4 bg-white p-2 rounded-pill shadow-sm d-inline-flex">
    <li class="nav-item">
      <button class="nav-link rounded-pill" [class.active]="activeTab === 'reports'" (click)="activeTab = 'reports'">
        <i class="bi bi-bar-chart-line me-2"></i>Reporte Mensual
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link rounded-pill" [class.active]="activeTab === 'employees'" (click)="activeTab = 'employees'">
        <i class="bi bi-people me-2"></i>Empleados
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link rounded-pill" [class.active]="activeTab === 'parameters'" (click)="activeTab = 'parameters'">
        <i class="bi bi-sliders me-2"></i>Parámetros Generales
      </button>
    </li>
  </ul>

  <!-- TAB: REPORTES (DASHBOARD) -->
  <div *ngIf="activeTab === 'reports'" class="animate-fade-in">
    <div class="card border-0 shadow-sm rounded-24 p-4 mb-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="fw-bold mb-0">Comisiones Calculadas</h5>
        <select class="form-select w-auto rounded-pill border-0 bg-light" [formControl]="monthFilterControl">
          <option *ngFor="let m of availableMonths" [value]="m.value">{{ m.label }}</option>
        </select>
      </div>

      <div class="table-responsive">
        <table class="table align-middle table-hover">
          <thead class="bg-light text-muted small text-uppercase">
            <tr>
              <th class="ps-3 py-3">Empleado</th>
              <th>Trabajos atendidos</th>
              <th>Metas (Items evaluados)</th>
              <th>Capacidad alcanzada</th>
              <th>Comisión mano de obra.</th>
              <th>Comisión repuestos</th>
              <th class="text-end pe-3">Total a pagar</th>
              <th class="text-center">Auditoría</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of reportData$ | async">
              <td class="ps-3">
                <div class="fw-bold">{{ row.employee.name }}</div>
                <span class="badge bg-secondary-subtle text-secondary border">{{ row.employee.type }}</span>
              </td>
              <td>
                <span class="fw-medium text-dark">{{ row.totalWorks }} Órdenes</span>
              </td>
              <td>
                <span class="text-primary">{{ row.eligibleWorks }} registros</span>
              </td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <div class="progress flex-grow-1" style="height: 6px;">
                    <div class="progress-bar bg-success" [style.width.%]="row.capacityReached"></div>
                  </div>
                  <span class="small fw-bold">{{ row.capacityReached | number:'1.0-0' }}%</span>
                </div>
                <small class="text-muted d-block mt-1">Escala aplicable: {{ row.laborCommissionRate }}%</small>
              </td>
              <td>
                <div class="fw-bold text-success">{{ row.laborCommissionAmount | currency:'DOP':'RD$' }}</div>
                <small class="text-muted">de {{ row.laborSales | currency:'DOP':'RD$' }} facturado</small>
              </td>
              <td>
                <div class="fw-bold text-info">{{ row.partsCommissionAmount | currency:'DOP':'RD$' }}</div>
                <small class="text-muted">de {{ row.partsSales | currency:'DOP':'RD$' }} (al {{ row.partsCommissionRate }}%)</small>
              </td>
              <td class="text-end pe-3 fw-bold fs-5 text-dark">
                {{ row.totalCommission | currency:'DOP':'RD$' }}
              </td>
              <td class="text-center">
                <button class="btn btn-sm btn-outline-primary rounded-pill shadow-sm" 
                        (click)="downloadEmployeeReport(row)" 
                        title="Descargar detalle en Excel/CSV">
                  <i class="bi bi-file-earmark-spreadsheet-fill me-1"></i> Bajar Detalle
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- TAB: EMPLEADOS -->
  <div *ngIf="activeTab === 'employees'" class="row g-4 animate-fade-in">
    <div class="col-md-5">
      <div class="card border-0 shadow-sm rounded-24">
        <div class="card-header bg-white p-4 border-0 d-flex justify-content-between align-items-center">
          <h5 class="fw-bold mb-0">Lista de Personal</h5>
          <button class="btn btn-outline-primary btn-sm rounded-pill" (click)="resetEmployeeForm()">+ Nuevo</button>
        </div>
        <div class="list-group list-group-flush px-2 pb-3">
          <button *ngFor="let emp of employees$ | async" class="list-group-item list-group-item-action rounded-16 mb-2 border-0 bg-light pointer"
                  [class.border-primary]="selectedEmployee?.id === emp.id"
                  (click)="selectEmployee(emp)">
            <div class="d-flex justify-content-between">
              <span class="fw-bold">{{ emp.name }}</span>
              <span class="badge rounded-pill" [ngClass]="emp.isActive ? 'bg-success' : 'bg-danger'">
                {{ emp.isActive ? 'Activo' : 'Inactivo' }}
              </span>
            </div>
            <small class="text-muted">{{ emp.type }}</small>
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <div class="card border-0 shadow-sm rounded-24 p-4">
        <h5 class="fw-bold mb-4">{{ selectedEmployee ? 'Editar Empleado' : 'Registrar Empleado' }}</h5>
        <form [formGroup]="employeeForm" (ngSubmit)="saveEmployee()">
          <div class="mb-3">
            <label class="form-label text-muted small fw-bold">Nombre Completo</label>
            <input type="text" class="form-control rounded-pill bg-light border-0 px-3" formControlName="name">
          </div>
          <div class="mb-3">
            <label class="form-label text-muted small fw-bold">Rol en el Taller</label>
            <select class="form-select rounded-pill bg-light border-0 px-3" formControlName="type">
              <option value="Mecánico">Mecánico</option>
              <option value="Asistente Taller">Asistente Taller</option>
            </select>
          </div>
          <div class="form-check form-switch mb-4">
            <input class="form-check-input" type="checkbox" role="switch" id="activeSwitch" formControlName="isActive">
            <label class="form-check-label" for="activeSwitch">Empleado Activo</label>
          </div>
          <div class="d-flex justify-content-between">
            <button *ngIf="selectedEmployee" type="button" class="btn btn-outline-danger rounded-pill px-4" (click)="deleteEmployee(selectedEmployee.id!)">Eliminar</button>
            <div class="ms-auto">
              <button type="button" class="btn btn-light rounded-pill px-4 me-2" (click)="resetEmployeeForm()">Cancelar</button>
              <button type="submit" class="btn btn-primary rounded-pill px-5 shadow" [disabled]="employeeForm.invalid || isSavingEmployee">Guardar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- TAB: PARÁMETROS -->
  <div *ngIf="activeTab === 'parameters'" class="animate-fade-in">
    <form [formGroup]="paramsForm" (ngSubmit)="saveParams()">
      <div class="row g-4">
        
        <!-- Capacidades por Servicio -->
        <div class="col-lg-6">
          <div class="card border-0 shadow-sm rounded-24 p-4 h-100" formGroupName="capacities">
            <h5 class="fw-bold mb-4 text-primary"><i class="bi bi-speedometer2 me-2"></i>Capacidad Tope (Mensual)</h5>
            <p class="small text-muted mb-4">Define la cantidad máxima esperada para calcular el % de alcance.</p>
            <div class="row g-3">
              <div class="col-md-12">
                <label class="small fw-bold">Servicios Ride</label>
                <input type="number" class="form-control rounded-pill bg-light border-0" formControlName="Ride">
              </div>
              <div class="col-md-12">
                <label class="small fw-bold">Instalaciones Ridewrap</label>
                <input type="number" class="form-control rounded-pill bg-light border-0" formControlName="Ridewrap">
              </div>
              <div class="col-md-12">
                <label class="small fw-bold">Servicios Full, Mecánica general & otros</label>
                <input type="number" class="form-control rounded-pill bg-light border-0" formControlName="Full">
              </div>
            </div>
          </div>
        </div>

        <!-- Repuestos y Artículos -->
        <div class="col-lg-6">
          <div class="card border-0 shadow-sm rounded-24 p-4 h-100">
            <h5 class="fw-bold mb-4 text-info"><i class="bi bi-box-seam me-2"></i>Comisión por repuestos</h5>
            <div class="mb-4">
              <label class="small fw-bold text-muted">Porcentaje de comisión fija (%)</label>
              <input type="number" step="0.1" class="form-control rounded-pill bg-light border-0 fs-4 text-info fw-bold" formControlName="productsCommissionPercentage">
            </div>
            <div>
              <label class="small fw-bold text-muted">Familias elegibles (Separadas por coma)</label>
              <textarea class="form-control rounded-16 bg-light border-0" rows="4" formControlName="eligibleProductCategories"></textarea>
              <small class="text-muted d-block mt-1">Ej: ACCESORIOS PARA BICIS, TRANSMISION, FRENOS</small>
            </div>
          </div>
        </div>

        <!-- Escalas Asistente -->
        <div class="col-lg-6">
          <div class="card border-0 shadow-sm rounded-24 p-4 h-100">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h5 class="fw-bold mb-0 text-success"><i class="bi bi-graph-up-arrow me-2"></i>Escala: Asistente Taller</h5>
              <button type="button" class="btn btn-sm btn-outline-success rounded-pill" (click)="addTier('assistantTiers')">+ Nivel</button>
            </div>
            <div formArrayName="assistantTiers">
              <div *ngFor="let t of assistantTiers.controls; let i=index" [formGroupName]="i" class="d-flex gap-2 mb-2 align-items-center p-2 bg-light rounded-pill">
                <span class="small ms-2 text-muted fw-bold">Al llegar al</span>
                <input type="number" class="form-control border-0 bg-transparent text-end fw-bold" formControlName="thresholdPercentage" style="width: 70px;">
                <span class="small text-muted">% de capacidad =</span>
                <input type="number" step="0.1" class="form-control border-0 bg-transparent text-success fw-bold" formControlName="commissionPercentage" style="width: 80px;">
                <span class="small text-muted">% Comisión</span>
                <button type="button" class="btn btn-link text-danger p-0 ms-auto me-3" (click)="removeTier('assistantTiers', i)"><i class="bi bi-x-circle-fill"></i></button>
              </div>
            </div>
            <p class="small text-muted mt-3"><i class="bi bi-info-circle me-1"></i>Los Asistentes aplican en Ride, Ridewrap y Full.</p>
          </div>
        </div>

        <!-- Escalas Mecánico -->
        <div class="col-lg-6">
          <div class="card border-0 shadow-sm rounded-24 p-4 h-100">
             <div class="d-flex justify-content-between align-items-center mb-4">
              <h5 class="fw-bold mb-0 text-warning-emphasis"><i class="bi bi-graph-up-arrow me-2"></i>Escala: Mecánico</h5>
              <button type="button" class="btn btn-sm btn-outline-warning rounded-pill" (click)="addTier('mechanicTiers')">+ Nivel</button>
            </div>
            <div formArrayName="mechanicTiers">
              <div *ngFor="let t of mechanicTiers.controls; let i=index" [formGroupName]="i" class="d-flex gap-2 mb-2 align-items-center p-2 bg-light rounded-pill">
                <span class="small ms-2 text-muted fw-bold">Al llegar al</span>
                <input type="number" class="form-control border-0 bg-transparent text-end fw-bold" formControlName="thresholdPercentage" style="width: 70px;">
                <span class="small text-muted">% de capacidad =</span>
                <input type="number" step="0.1" class="form-control border-0 bg-transparent text-warning-emphasis fw-bold" formControlName="commissionPercentage" style="width: 80px;">
                <span class="small text-muted">% Comisión</span>
                <button type="button" class="btn btn-link text-danger p-0 ms-auto me-3" (click)="removeTier('mechanicTiers', i)"><i class="bi bi-x-circle-fill"></i></button>
              </div>
            </div>
            <p class="small text-muted mt-3"><i class="bi bi-info-circle me-1"></i>Los Mecánicos SÓLO aplican en servicios Full.</p>
          </div>
        </div>

        <!-- Botón Guardar -->
        <div class="col-12 text-end mt-4">
          <button type="submit" class="btn btn-dark rounded-pill px-5 py-2 shadow-lg" [disabled]="paramsForm.invalid || isSavingParams">
            {{ isSavingParams ? 'Guardando...' : 'Guardar Todos los Parámetros' }}
          </button>
        </div>

      </div>
    </form>
  </div>
</div>